module.exports = __webpack_public_path__ + "media/pages/assets/images/time-turner-8f0c38f665736590b94628234d043b12.svg";